import Constants from '@/constants';
export const getFilterableStatus = (status: string, isCompliance: boolean) => {
  if (
    [
      Constants.LEARN_UPON_TRAINING_PLANS.PASSED,
      Constants.LEARN_UPON_TRAINING_PLANS.COMPLETED,
    ].includes(status) &&
    isCompliance
  ) {
    return Constants.LEARN_UPON_TRAINING_PLANS.COMPLETED;
  }

  if (
    [
      Constants.LEARN_UPON_TRAINING_PLANS.NOT_COMPLETED,
      Constants.LEARN_UPON_TRAINING_PLANS.CANCELLED,
      Constants.LEARN_UPON_TRAINING_PLANS.FAILED,
      Constants.LEARN_UPON_TRAINING_PLANS.IN_PROGRESS,
      Constants.LEARN_UPON_TRAINING_PLANS.NO_SHOW,
      Constants.LEARN_UPON_TRAINING_PLANS.NOT_STARTED,
      Constants.LEARN_UPON_TRAINING_PLANS.PENDING_REVIEW,
      '',
    ].includes(status) &&
    isCompliance
  ) {
    return Constants.LEARN_UPON_TRAINING_PLANS.NOT_COMPLETED;
  }

  if (
    [
      Constants.TRAINING_PLANS.NOT_COMPLETED,
      Constants.TRAINING_PLANS.IN_PROGRESS,
      Constants.TRAINING_PLANS.NOT_STARTED,
      '',
    ].includes(status) &&
    !isCompliance
  ) {
    return Constants.TRAINING_PLANS.NOT_COMPLETED;
  }

  if ([Constants.TRAINING_PLANS.COMPLETED].includes(status) && !isCompliance) {
    return Constants.TRAINING_PLANS.COMPLETED;
  } else return Constants.TRAINING_PLANS.NOT_COMPLETED;
};
